import { useState } from "react";
import Avatar from "../../components/notes/Avatar";
import MediaGallery from "../../components/media/MediaGallery";
import DOMPurify from 'dompurify';
import TimeAgo from "../../components/timeAgo/TimeAgo";
import { FaClock } from "react-icons/fa";  

const PromotionDetailCard = ({images, videos, title, attachments, description, cost, type, state, city, pin_code, photo, creater, createdOn}) => {
  // eslint-disable-next-line no-unused-vars
  const [readMore, setReadMore] = useState(false);
  const charLimit = 200;
  // eslint-disable-next-line no-unused-vars
  const isLong = description?.length > charLimit;
  // eslint-disable-next-line no-unused-vars
  const toggleReadMore = () => setReadMore((prev) => !prev);
  const descriptionWords = description?.trim().split(' ') || [];
  const [showFullDescription, setShowFullDescription] = useState(false);
  const isLongDescription = descriptionWords.length > 50;
  const displayedDescription =
    isLongDescription && !showFullDescription
      ? descriptionWords.slice(0, 50).join(' ') + '...'
      : description;

  return ( 
    <div>

      <MediaGallery
        images={images}
        promotion_videos={videos}
        attachments={attachments}
      /> 

      {/* Title & Description */}
      <div className="mb-4">
        <h1 className="fw-bold mb-3 text-dark">{title}</h1>
        {/* Description */}
        <div className="mt-4">
          <h5 className="text-muted">Description</h5>
          <div
            className="text-dark"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(displayedDescription),
            }}
          />
          {isLongDescription && (
            <button
              className="btn btn-link p-0 mt-2"
              onClick={() => setShowFullDescription(!showFullDescription)}
            >
              {showFullDescription ? 'Read Less' : 'Read More'}
            </button>
          )}
        </div>
      </div>

      {/* Price */}
      <div className="my-4">
        <h2 className="fw-bold  text-success mt-1 ">₹{cost}</h2>
      </div>


      {/* Property Info */}
      <div className="d-flex gap-3 flex-wrap">
        <span className="badge text-bg-warning fs-5">{type}</span>
        <span className="badge text-bg-info fs-5">{state}</span>
        <span className="badge text-bg-secondary fs-5">{city}</span>
        <span className="badge text-bg-dark fs-5">{pin_code}</span>
      </div>
    
      {/* Creator Info */}
      {/* <div className="d-flex align-items-center mt-5">
        <Avatar 
          src={photo} 
          icon={creater}
          size={45}
          className="rounded-circle shadow-sm "
        />
        <span className="text-muted px-2">
          <span className="fw-semibold">Listed by</span> {creater}
        </span>
      </div> */}
      <div className="mt-5 p-3 ">
        <div className="row align-items-center">
          
          {/* Left: Creator Info */}
          <div className="col-md-6 d-flex align-items-center">
            <Avatar src={photo} icon={creater} size={48} />
            <div className="ms-3">
              <div className="text-muted small">Listed By</div>
              <div className="fw-semibold text-dark">{creater}</div>
            </div>
          </div>

          {/* Right: Created + Published Info */}
          {createdOn && 
            <div className="col-md-6 d-flex flex-column align-items-md-end mt-3 mt-md-0">
              <div className="d-flex align-items-center mb-1">
                <FaClock className="me-2 text-secondary" />
                <div className="text-muted small">
                  Created <TimeAgo timestamp={createdOn} />
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  );
}
export default PromotionDetailCard;